import React, { useEffect, useState } from 'react';
import { Timer, Zap } from 'lucide-react';
export function UrgencyBar() {
  // Start at 13:47 minutes for this visit
  const [timeLeft, setTimeLeft] = useState({
    minutes: 13,
    seconds: 47
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (value: number) => value.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-red-600 text-white shadow-lg shadow-red-900/20" data-id="element-268">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm sm:text-base font-medium" data-id="element-269">
        <div className="flex items-center gap-2 text-center" data-id="element-270">
          <Zap className="w-5 h-5 animate-pulse text-red-200" data-id="element-271" />
          <span data-id="element-272">
            <strong className="font-extrabold tracking-wide" data-id="element-273">
              OFERTA FLASH ACTIVADA:
            </strong>{' '}
            76% OFF SOLO DURANTE ESTA VISITA
          </span>
        </div>

        <div className="flex items-center gap-4 bg-red-700/50 px-3 py-1 rounded-full border border-red-500/30" data-id="element-274">
          <div className="flex items-center gap-1.5 font-mono text-lg font-bold tracking-wider" data-id="element-275">
            <Timer className="w-4 h-4 text-red-200" data-id="element-276" />
            <span data-id="element-277">{formatTime(timeLeft.minutes)}</span>:
            <span className="text-red-200" data-id="element-278">{formatTime(timeLeft.seconds)}</span>
          </div>
          <div className="hidden md:block w-px h-4 bg-red-500/50" data-id="element-279"></div>
          <span className="text-xs sm:text-sm text-red-100 font-semibold animate-pulse" data-id="element-280">
            Tu descuento está reservado
          </span>
        </div>
      </div>
    </div>;
}